var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 25,
    viewBox: "0 0 18 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 11.9103C8.21856 11.9103 7.46912 11.5999 6.91656 11.0473C6.364 10.4947 6.05357 9.74531 6.05357 8.96387C6.05357 8.18243 6.364 7.43299 6.91656 6.88043C7.46912 6.32787 8.21856 6.01744 9 6.01744C9.78144 6.01744 10.5309 6.32787 11.0834 6.88043C11.636 7.43299 11.9464 8.18243 11.9464 8.96387C11.9464 9.3508 11.8702 9.73394 11.7221 10.0914C11.5741 10.4489 11.357 10.7737 11.0834 11.0473C10.8098 11.3209 10.485 11.5379 10.1276 11.686C9.77007 11.8341 9.38693 11.9103 9 11.9103ZM9 0.713867C6.81196 0.713867 4.71354 1.58306 3.16637 3.13024C1.61919 4.67741 0.75 6.77583 0.75 8.96387C0.75 15.1514 9 24.2853 9 24.2853C9 24.2853 17.25 15.1514 17.25 8.96387C17.25 6.77583 16.3808 4.67741 14.8336 3.13024C13.2865 1.58306 11.188 0.713867 9 0.713867Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.81ac8273bdae48cf57fc32f90c6f06d9.svg";
export { ForwardRef as ReactComponent };